import { IncidentModel } from './incident.model';

export class IncidentConvictionModel extends IncidentModel {

    public incidentConvictionId: number;
    public citingAgencyTypeId: number;
    public courtDispositionCodeTypeId: number;
    public accidentTypeId: number;
    public courtOrderedInterlockMonthsTypeId: number;
    public courtActionFlagTypeId: number;
    public courtActionCodeTypeId: number;
    public courtOrderedActionTypeId: number;
    public civilCriminalViolationTypeId: number;
    public drugViolationTypeId: number;
    public courtId: number;
    public courtTypeId: number = null;
    public plateTypeId: number;
    public vehicleRegistrationJurisdictionId: number;
    public vehicleLicensePlateNumber: string;
    public complaintNumber: string;
    public complaintNumberCount = '0';
    public convictionSentencingAuthorityTypeId: number;
    public alcoholClassIndicator: boolean;
    public complaintSequenceNumber: number;
    public cdlHolderIndicator = false;
    public underlyingViolationCode: string;
    public underlyingAcdCodeId: number;
    public vehicleMake: string;
    public driverLicenseClass: string;
    public approximateSpeed: number;
    public lawfulSpeed: number;
    public withdrawalNumberOfMonths: number;
    public commercialMotorVehicleIndicator = false;
    public commercialMotorVehicleIndicatorValue = '2';
    public hazardousMaterialIndicator = false;
    public hazardousMaterialIndicatorValue = '2';
    public passengerIndicator = false;
    public operatingHireFlag = false;
    public courtOrderedIgnitionInterlockDeviceIndicator = false;
    public felonyIndicator = false;
    public alternativeServiceProcessIndicator = false;
    public dispositionDate: Date;
    public withdrawalBeginningActionDate: any;
    public withdrawalEndingActionDate: any;
    public restrictionBeginningActionDate: any;
    public restrictionEndingActionDate: any;
    public dateOfExtract: any;
    public citingAgencyTypeDisplayValue: string;
    public dispositionCodeTypeDisplayValue: string;
    public accidentTypeDisplayValue: string;
    public courtOrderedInterlockMonthsTypeDisplayValue: string;
    public courtActionFlagTypeDisplayValue: string;
    public courtActionCodeTypeDisplayValue: string;
    public courtOrderedActionTypeDisplayValue: string;
    public civilCriminalViolationTypeDisplayValue: string;
    public drugViolationTypeDisplayValue: string;
    public courtName: string;
    public plateTypeDisplayValue: string;
    public driverLicenseJurisdictionId: number;
    public driverLicenseNumber: string;
    public offenseClassificationTypeId: number;
    public cdlHolderIndicatorValue: string; // NOTE: Used for ROOSC and must be explicitly set if needed
    public driverConvictionOffenseDescriptionText: string; // NOTE: Used for ROOSC and must be explicitly set if needed
    public convictionDate: Date;
}
